export default "__VITE_ASSET__l2b7OUXb__"